<template>
    <!--Wave弹出窗-->
    <a-modal
            :title="$t('pubGicSet.WaveID')"
            :visible="queryWindow"
            width="80%"
            :maskClosable="false"
            :zIndex="99"
            @cancel="cancelQuerySearch">
        <template slot="footer">
            <a-button type="primary" @click="confirmButton">{{ $t('publicLang.Confirm') }}</a-button>
        </template>
        <a-row>
            <a-row type="flex" justify="space-between">
                <a-col>
                    <a-row type="flex" justify="start">
                        <a-col >
                            <a-input size="small" style="width: 150px" v-model="queryCode" @pressEnter="init"/>
                        </a-col>
                        <img class="funcButton" src="../../../assets/img/search.png" width="22" height="22" @click="init" :title="$t('batchReceive.Query')">
                        <img class="funcButton" src="../../../assets/img/refresh2.png" width="22" height="22" @click="reset" :title="$t('pubGicSet.Clear')">
                    </a-row>
                </a-col>
                <a-col style="float: right">
                    <a-pagination
                            :pageSizeOptions="pageSizeOptions"
                            :showTotal="total => `${$t('generic.totalOf')} ${pagingTotal} ${$t('generic.Records')}`"
                            size="small"
                            :total="pagingTotal"
                            v-model="currentVal"
                            :pageSize.sync="pagingSize"
                            @change="tableChangePage"
                            @showSizeChange="onShowSizeChange"
                            showSizeChanger
                    />
                </a-col>
            </a-row>
            <a-row style="height: 65vh;" class="mt">
                <vxe-table
                        stripe
                        resizable
                        border
                        highlight-hover-column
                        highlight-hover-row
                        highlightCurrentRow
                        show-header-overflow
                        show-overflow
                        :sort-config="{multiple: true, trigger: 'cell'}"
                        align="center"
                        height="auto"
                        size="mini"
                        ref="refWaveNoTable"
                        :checkbox-config="{checkField:'checked',trigger:'row'}"
                        @checkbox-change="selectEvent"
                        :data="PagingGridList">
                    <template v-slot:empty>
                        <a-empty></a-empty>
                    </template>
                    <vxe-table-column type="checkbox" width="50"></vxe-table-column>
                    <vxe-table-column type="seq" :title="$t('job.Seq')" width="60"></vxe-table-column>
                    <vxe-table-column field="WAVE_ID" :title="$t('pubGicSet.WaveID')" sortable></vxe-table-column>
                    <vxe-table-column field="COUNT_SSCC" title="No.of SSCC" sortable></vxe-table-column>
                </vxe-table>
            </a-row>
        </a-row>
    </a-modal>
</template>

<script>
import ajax from "../../../api/ajax";
import api from "../../../api/url";
import XEUtils from "xe-utils";
import cookie from '../../../api/cookie';

export default{
    data(){
        return{
            queryWindow:false,
            pagingTotal: 0, // 总数
            pagingSize: Number.parseInt(sessionStorage.getItem('pageSize') || '30'), // 条数
            currentVal: 1, // 当前选中的页数
            PagingGridList: [],//明细列表数据
            pageSizeOptions:['10', '20', '30', '40','100','200','500','1000'],
            queryCode:'',
            containerNo:'',
            uid:'',

        }
    },
    methods:{
        show(data,uid){
            this.queryCode = "";
            this.containerNo = data;
            this.uid = uid;
            this.queryWindow = true;
            this.PagingGridList=[];
        },
        tableChangePage(current) {
            this.currentVal = current;
            this.query();
        },
        onShowSizeChange(current, pageSize) {//选择下拉框后触发事件
            this.currentVal = current;
            this.pagingSize = pageSize;
            this.query();
        },
        cancelQuerySearch(){
            this.queryWindow = false;

        },
        init(){
            this.currentVal = 1;
            this.query();
        },
        query(){
            let params = new FormData();
            params.append("waveNo",this.queryCode);
            ajax.post(api.LOADINGSEARCHWAVECARTON,params).then(res=>{
                if(res.code == 200){
                    this.PagingGridList = res.data;//列表
                    this.pagingTotal = res.total;//总数
                }else{
                    this.$customMessage.warning(res.msg,2);
                    return;
                }
            })
        },
        reset(){//重置
            this.queryCode = "";
        },

        confirmButton() {//双击弹出修改窗口
            let data = this.$refs.refWaveNoTable.getCheckboxRecords();
            if(data.length != 1){
                this.$customMessage.warning(this.$t('publicLang.pleaseOneOnly'),2);
                return;
            }

            let params = {
                cartonToContainer: {
                    containerNo: this.containerNo,
                    waveId: data[0].WAVE_ID
                },
                uid:this.uid,
                remove:false
            }
            ajax.post(api.LOADINGSCANBYWAVE,params).then(res=>{
                if(res.code == 200){
                    this.$emit("checkedCode", data);
                }else{
                    this.$customMessage.warning(res.msg,2);
                    return;
                }
            })




            this.queryWindow = false;
        },
        selectEvent(data){//只能选中一条数据
            let row = data.row
            let isSelect = this.$refs.refWaveNoTable.isCheckedByCheckboxRow(row)
            this.$refs.refWaveNoTable.setAllCheckboxRow(false)
            this.$refs.refWaveNoTable.setCheckboxRow(row, isSelect)
        }
    }
}
</script>

<style scoped>
    .funcButton{
        cursor: pointer;
        margin-left: 5px;
    }
</style>